import { Component, effect, ElementRef, signal, viewChild } from '@angular/core';

@Component({
  selector: 'app-password-input',
  imports: [],
  templateUrl: './password-input.component.html',
})
export class PasswordInputComponent {
  public showPassword = signal(false);

  public inputEle = viewChild<ElementRef<HTMLElement>>('inputEle');

  public togglePasswordVisibility() {
    this.showPassword.update((value) => !value);
  }

  constructor() {
    effect(() => {
      const showPassword = this.showPassword();
      const inputEle = this.inputEle();

      if (!inputEle) {
        return;
      }

      const siblingInput = inputEle.nativeElement.previousSibling;

      if (siblingInput?.nodeName !== 'INPUT') {
        return;
      }
      (siblingInput as HTMLInputElement).type = showPassword ? 'text' : 'password';
    });
  }
}
